// extracted by css-extract-rspack-plugin
export default {"item":"LUrK5468Jj4CLsTK"};